import { get, post } from '@barbanet/api-service'

import {
	CloseVehicleRequest,
	InquiryRequest,
	VehicleAvailableResponse,
	VehicleInfoResponse,
	VehiclesRequest,
	VehiclesResponse
} from '../types/dto/driver'

export const vehicleService = (data: VehiclesRequest) =>
	post<VehiclesRequest, VehiclesResponse>('core', 'vehicles', {
		data
	})

export const closeVehicleService = (id: string) =>
	post<CloseVehicleRequest>('core', `vehicles/${id}/close`)
export const vehicleAvailableService = () =>
	get<VehicleAvailableResponse>('core', 'vehicles/available')

export const vehicleInfoService = () =>
	get<VehicleInfoResponse>('core', 'vehicles/info')

export const reInquiryHeavyTruck = (id: string, type: string) =>
	post<InquiryRequest>('core', `vehicles/${id}/${type}/inquiry`)
